import FolderIcon from '@material-ui/icons/Folder';
export default function SciugoFolderIcon({fontSize}){
  return <FolderIcon style={{color:'rgb(81,207,255)',fontSize:16}}/> 

}
